import useReveal from "../../hooks/useReveal";

import "./experience.scss";

const roles = [
  {
    company: "Volleyball Legends",
    title: "Co-Founder & Lead Engineer",
    period: "Dec 2024 to present",
    summary: "The biggest volleyball game in the world, built on Roblox. I work on the systems that keep it running at scale.",
    points: [
      "Contribute to a game with over 4 billion total plays, the biggest volleyball game in the world on Roblox.",
      "Build the backend architecture and data systems serving 124 million monthly active users and nearly 500,000 concurrent players.",
      "Work on server infrastructure for real-time gameplay: matchmaking, state synchronization, and game consistency at scale.",
      "Run a team of 5+ engineers with Scrum, daily standups, and onboarding docs that get new folks contributing in under a day.",
      "Build analytics and monitoring dashboards for performance tuning and incident response, backed by TDD and continuous integration.",
    ],
    tags: ["Luau", "TypeScript", "Distributed Systems", "Live Ops", "Team Leadership"],
  },
  {
    company: "Amgen",
    title: "Software Engineer Intern",
    period: "May to Aug 2025",
    summary: "AI tooling and data engineering for research at one of the world's largest biotech companies.",
    points: [
      "Built an AI research assistant for epidemiologists that cut literature review turnaround by roughly 40%.",
      "Ingested thousands of clinical studies into a cloud data lake for downstream analytics.",
      "Made data pipelines configurable so new sources go live in hours instead of weeks.",
      "Wrote end-to-end tests against live environments, not mocks.",
    ],
    tags: ["Python", "AWS", "Databricks", "Data Engineering"],
  },
  {
    company: "HyperPenguin Games",
    title: "Junior Programmer",
    period: "2023",
    summary: "Full-stack game development in a large microservice codebase, working in a Kanban team.",
    points: [
      "Implemented back-end features across monetization, data storage, and player trading systems in TypeScript.",
      "Cut CPU load by up to 15%, finding the hot paths through unit, integration, and functional testing.",
      "Debugged multithreaded systems around event handling and locks.",
      "Developed and deployed interactive front-end components: transition screens, shopping pages, and button animations.",
    ],
    tags: ["TypeScript", "REST", "Testing", "Microservices"],
  },
  {
    company: "2BRO Studios",
    title: "Founder & Lead Programmer",
    period: "2021 to 2023",
    summary: "Founded and led an indie game studio of 20, managing production and engineering across multiple titles.",
    points: [
      "Managed end-to-end production of 4 games, reaching over 5 million plays in their first quarter.",
      "Peaked at 1,700,000 monthly active users across the catalog.",
      "Ran Scrum with daily standups, improving team coordination and delivery speed.",
      "Set the studio's coding patterns, data structures, and security practices.",
    ],
    tags: ["Leadership", "TypeScript", "Production", "Game Design"],
  },
];

export function Role({ company, title, period, summary, points, tags }) {
  const [ref, , cls] = useReveal({ threshold: 0.12 });
  return (
    <article className={`role ${cls}`} ref={ref}>
      <header className="role-head">
        <h3>{company}</h3>
        <p className="role-title">{title}</p>
        <p className="role-period label">{period}</p>
      </header>
      <div className="role-body">
        {summary && <p className="role-summary">{summary}</p>}
        {points && (
          <ul className="role-points">
            {points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        )}
        {tags && (
          <ul className="role-tags" aria-label="Skills">
            {tags.map((tag) => (
              <li key={tag}>{tag}</li>
            ))}
          </ul>
        )}
      </div>
    </article>
  );
}

export default function Experience() {
  return (
    <div className="experience" id="experience">
      <div className="roles">
        {roles.map((role) => (
          <Role key={role.company} {...role} />
        ))}
      </div>
    </div>
  );
}
